import React, { useState } from 'react';
import './App.scss';
import ReactPageScroller from 'react-page-scroller';
import ProgressBar from '../components/ProgressBar/ProgressBar';
import FirstComponent from "../slides/_1FirstComponent";
import RandomCirclesComponent from "../slides/_2RandomCirclesComponent";
import StatsComponent from "../slides/_3StatsComponent";
import PhaseOneComponent from '../slides/_6PhaseOneComponent';
import GiantBallComponent from '../slides/_5GiantCircleComponent';
import PhotoComponent from '../slides/_4PhotoComponent';
import StartComponent from "../slides/_6StartComponent";
import StageTwoComponent from '../slides/_8StageTwoComponent';
import PhaseTwoComponent from '../slides/_9PhaseTwoComponent';
import GiantPipeComponent from '../slides/_11GiantPipeComponent';
import GiantPipeExitComponent from '../slides/_12GiantPipeExitComponent';
import PipesThreeComponent from '../slides/_13PipesThreeComponent'
import PicturePipeComponent from '../slides/_14PicturePipeComponent';
import DrugApprovalComponent from '../slides/_20DrugApprovalComponent';
import BehindTheScenesComponent from '../slides/_21BehindTheScenesComponent';
import CynthiaComponent from '../slides/CynthiaComponent';
import PhaseFourComponent from '../slides/PhaseFourComponent';
import EndPhaseFourComponent from '../slides/EndPhaseFourComponent';
import EndPipesComponent from '../slides/EndPipesComponent';
import JohnComponent from '../slides/JohnComponent';
import VialsComponent from '../slides/VialsComponent';
import PhaseThreeComponent from '../slides/PhaseThreeComponent';
import SplitPipeComponent from '../slides/SplitPipeComponent';
import LastSlideComponent from '../slides/LastSlideComponent';

import image1 from '../assets/elements/img/Chapter-image-1.png';
import image3 from '../assets/elements/img/Chapter-image-2.png';

const message1 = 'The key to discovering new treatments and medicines for these and other diseases lies in clinical trials. A clinical trial is a research study conducted in partnership with patients.';
const message2 = 'Even after approval, the science doesn’t stop. In Phase 4 trials, scientists continue to collect and share data, thus continuing to expand and grow their understanding of the medicine.';

export default () => {
  const [activePage, setActivePage] = useState(0);
  const handlePageOnChange = number => setActivePage(number);
  const handleClickOnPhase = phaseNumber => setActivePage(phaseNumber);

  return (
    <>
      <ProgressBar activePage={activePage} totalPages={25} onHandleClickOnPhase={handleClickOnPhase} />
      <ReactPageScroller
        pageOnChange={handlePageOnChange} 
        customPageNumber={activePage}
        animationTimerBuffer={1000}
        renderAllPagesOnFirstRender={false}>
        <FirstComponent isActive={activePage === 0} goToNextSlide={() => handleClickOnPhase(1)} />
        <RandomCirclesComponent isActive={activePage === 1} />
        <StatsComponent isActive={activePage === 2} />
        <PhotoComponent isActive={activePage === 3} image={image1} message={message1} />
        <GiantBallComponent isActive={activePage === 4} />
        <StartComponent isActive={activePage === 5} goToNextSlide={() => handleClickOnPhase(6)} />
        <PhaseOneComponent isActive={activePage === 6} />
        <StageTwoComponent isActive={activePage === 7} goToNextSlide={() => handleClickOnPhase(8)} />
        <PhaseTwoComponent isActive={activePage === 8} />
        <GiantPipeComponent isActive={activePage === 9} />
        <GiantPipeExitComponent isActive={activePage === 10} />
        <PipesThreeComponent isActive={activePage === 11} />
        <PicturePipeComponent isActive={activePage === 12} />
        <VialsComponent isActive={activePage === 13} goToNextSlide={() => handleClickOnPhase(14)} />
        <PhaseThreeComponent isActive={activePage === 14} />
        <SplitPipeComponent isActive={activePage === 15} />
        <DrugApprovalComponent isActive={activePage === 16} />
        <BehindTheScenesComponent isActive={activePage === 17} />
        <CynthiaComponent isActive={activePage === 18} />
        <PhaseFourComponent isActive={activePage === 19} goToNextSlide={() => handleClickOnPhase(20)} />
        <EndPhaseFourComponent isActive={activePage === 20} />
        <PhotoComponent isActive={activePage === 21} image={image3} message={message2} />
        <EndPipesComponent isActive={activePage === 22} />
        <JohnComponent isActive={activePage === 23} />
        <LastSlideComponent isActive={activePage === 24} />
      </ReactPageScroller>
    </>
  );
};
